export const sortMenu = [
    "Latest",
    "Featured",
    "Top Rated",
    "Price(Lowest First)",
    "Price(Highest First)"
];

export const filterMenu = [
    {
        id: 1,
        title: "Brands",
        menu: [
            "JBL",
            "BoAt",
            "Sony"
        ],
    },
    {
        id: 2,
        title: "Category",
        menu: [
            "Headphones",
            "Earbuds",
            "Earphones",
            "Neckbands"
        ],
    },
    {
        id: 3,
        title: "Type",
        menu: [
            "In-Ear",
            "On-Ear",
            "Over-Ear",
        ],
    },
    {
        id: 4,
        title: "Price",
        menu: [
            "500 & Below",
            "501 - 1,000",
            "1,001 - 1,500",
            "1,501 - 3,000",
            "3,001 - 5,000",
            "5,001 & Above"
        ],
    },
];